import React, { useEffect } from 'react';
import styled from '@emotion/styled';

import { Flex } from '@chakra-ui/react';

import DemoButton from './DemoButton';
import DemoIcon from './DemoIcon';
import DemoCalendar from './DemoCalendar';
import DemoDatePicker from './DemoDatePicker';
import DemoAlert from './DemoAlert';
import DemoModal from './DemoModal';
import DemoText from './DemoText';
import DemoGuestDropdown from './DemoGuestDropdown';
import DemoCheckbox from './DemoCheckbox';
import DemoRadio from './DemoRadio';
import DemoStepper from './DemoStepper';
import DemoImageList from './DemoImageList';
import DemoLangCurrencySelect from './DemoLangCurrencySelect';
import DemoPills from './DemoPills';
import DemoBadges from './DemoBadge';
import DemoRoomDetailBox from './DemoRoomDetailBox';
import DemoToolTip from './DemoTooltip';
import DemoShoppingCart from './DemoShoppingCart';
import DemoTabs from './DemoTabs';
import DemoCard from './DemoCard';

const DemoRoot = styled.div`
    background-color: white;
    min-height: 100%;
    padding: 1rem;
    .flex-column {
        display: flex;
        flex-direction: column;
    }

    h1 {
        font-size: 2.5rem;
    }

    h2 {
        font-size: 1.5rem;
    }
`;

const DemoPage: React.FunctionComponent = () => {
  useEffect(() => {
    document.title = 'BE Components Demo';
  }, []);

  return (
    <DemoRoot>
      <Flex align={'center'} justifyContent="center">
        <Flex
          width={768}
          maxWidth={'100%'}
          direction={'column'}
          gap={8}
          mb={'500px'}
        >
          <h1>Components Demo</h1>
          <DemoCard />
          <DemoButton />
          <DemoStepper />
          <DemoGuestDropdown />
          <DemoCheckbox />
          <DemoRadio />
          <DemoImageList />
          <DemoLangCurrencySelect />
          <DemoPills />
          <DemoIcon />
          <DemoBadges />
          <DemoDatePicker />
          <DemoCalendar />
          <DemoAlert />
          <DemoModal />
          <DemoText />
          <DemoRoomDetailBox />
          <DemoToolTip />
          <DemoShoppingCart />
          <DemoTabs />
        </Flex>
      </Flex>
    </DemoRoot>
  );
};

export default DemoPage;
